function setCookie(cname, cvalue, exdays) {
	const d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	let expires = "expires="+ d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
	let name = cname + "=";
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for(let i = 0; i <ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

function YLWPUXsendEvent(event_name, event_value, event_type = 'ywp_ux_tracker') {
	if (window.gtag) {
		console.log('gtag exists');
		gtag("event", event_type, {
			name: event_name,
			value: event_value,
			page_location: window.location.href
		});
	} else {
		console.log('No GTAG');
	}
}

function setupTrackerlinks() {
	let trackerLinks = document.querySelectorAll('[data-ywpuxtrack="true"]');

	for(const trackerLink of trackerLinks) {
		trackerLink.addEventListener('click', ( event ) => {
			if("true" !== trackerLink.getAttribute('data-uxclicked')) {
				event.preventDefault();

				let eventName = trackerLink.getAttribute('data-ywp_track_name');
				let eventValue = trackerLink.getAttribute('data-ywp_track_value');

				let href = trackerLink.getAttribute('href');

				YLWPUXsendEvent(eventName, eventValue);
				trackerLink.setAttribute('data-uxclicked', "true");
				window.location.href = href;

			} else {

			}

		})
	}
}
function setupTestVersion() {
	let testVersion = getCookie('ywptentrset');

	if (('' === testVersion) || (testVersion !== 'a' && testVersion !== 'b')) {
		testVersion = Math.random() < 0.5 ? 'a' : 'b';
		setCookie('ywptentrset', testVersion, 7);
	}

	return testVersion;
}
function setupABElements(testVersion) {

	let abElements = document.querySelectorAll('[data-abtest="true"]');

	for(const abElement of abElements) {
		let blockVersion = abElement.getAttribute('data-ywptentrver');
		if (blockVersion.toLowerCase() !== testVersion.toLowerCase()) {
			abElement.remove();
		}
	}
}

document.addEventListener("DOMContentLoaded", function(event) {
	let testVersion = setupTestVersion();
	setupTrackerlinks();
	setupABElements(testVersion);

});
